import { Alert } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { SuitcaseIcon, LargeBaggageIcon } from "src/assets/Icons";

export default function BaggageGuidelinesContent() {
  const { t } = useTranslation();
  return (
    <div className="custom-scrollbar flex w-full flex-col items-center gap-4 p-4">
      <Alert title={t("Flights.details.ssr.baggageGuidelinesWarning")} type="warning" showIcon className="w-full! m-0!" />
      <div className="flex w-full flex-col">
        <div className="font-semibold">{t("Flights.details.ssr.carryOnBaggage")}</div>
        <div className="flex items-center justify-between gap-8 md:flex-row flex-col">
          <div className="text-sm">
            <Trans
              i18nKey="Flights.details.ssr.baggageGuidelinesDescription"
              components={[<span className="text-font-active font-semibold" />]}
            />
          </div>
          <div className="w-30 h-30 flex shrink-0 items-center justify-center">
            <SuitcaseIcon />
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col">
        <div className="font-semibold">{t("Flights.details.ssr.checkedBaggage")}</div>
        <div className="flex items-center justify-between gap-8 md:flex-row flex-col">
          <div className="text-sm">
            <Trans
              i18nKey="Flights.details.ssr.baggageGuidelinesDescription"
              components={[<span className="text-font-active font-semibold" />]}
            />
          </div>
          <div className="w-30 h-30 flex shrink-0 items-center justify-center">
            <LargeBaggageIcon />
          </div>
        </div>
      </div>
    </div>
  );
}
